import {useEffect, useState} from "react";
import {Autocomplete, CircularProgress, Grid, IconButton, InputAdornment, TextField} from "@mui/material";
import {LocationOn} from "@mui/icons-material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Api from "../../inc/Api";
import PropTypes from "prop-types";
import Alert from "../../inc/Alert";
import Toast from "../../inc/Toast";

let timeoutAC;

function FAddress(props) {

    const value = props.value || {
        lat    : '',
        lng    : '',
        address: '',
    };

    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState('');
    const [options, setOptions] = useState([]);

    let permissionStatus = null;

    useEffect(() => {
        if (query) {
            if (timeoutAC)
                clearTimeout(timeoutAC);

            timeoutAC = setTimeout(() => {

                setLoading(true);
                Api.post('/map/autocomplete', {query}, rsp => {
                    setLoading(false);
                    setOptions(rsp.ok ? rsp.items : []);
                });

            }, 500);
        }
    }, [query]);

    function checkCurrentLocation() {
        if (navigator.geolocation) {
            setLoading(true);
            navigator.permissions.query({name: 'geolocation'}).then(status => {
                permissionStatus = status;
                console.log('permissionStatus', permissionStatus);

                if (permissionStatus.state === 'denied') {
                    setLoading(false);
                    console.log('aceptar permisos');
                    Alert.error('Por favor, permite el acceso a la ubicación en la configuración de tu navegador.');
                } else {
                    navigator.geolocation.getCurrentPosition(locationSuccess, err => {
                        setLoading(false);
                        console.log('locationError', err);
                        Toast.warning('Debes aceptar el permiso de ubicación.');
                    }, {
                        enableHighAccuracy: true,
                    });
                }
            });
        }
    }

    function locationSuccess(loc) {
        let lat = loc.coords.latitude;
        let lng = loc.coords.longitude;

        setLoading(true);
        Api.post('/map/geocode', {lat, lng}, rsp => {
            setLoading(false);
            if (rsp.ok) {
                props.onChange({
                    address: rsp.address,
                    lat    : rsp.lat,
                    lng    : rsp.lng,
                });
            }
        });

        console.log('locationSuccess', loc);
    }

    return (
        <Autocomplete
            getOptionLabel={(option) => option.address}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            fullWidth
            value={value}
            disabled={props.disabled}
            noOptionsText={query
                ? loading
                    ? 'Buscando...'
                    : 'No hay ubicaciones.'
                : 'Escribe una dirección.'}
            onChange={(event, newValue) => {
                console.log('newValue', newValue);

                if (newValue) {
                    props.onChange({
                        ...value,
                        address: `${newValue.name}, ${newValue.address}`,
                    });
                    setLoading(true);
                    Api.post('/map/place', {id: newValue.id}, rsp => {
                        setLoading(false);
                        if (rsp.ok) {
                            props.onChange({
                                address: `${newValue.name}, ${newValue.address}`,
                                lat    : rsp.lat,
                                lng    : rsp.lng
                            });
                        }
                    }, false);
                } else {
                    props.onChange({
                        ...value,
                        address: '',
                        lat    : 0,
                        lng    : 0,
                    });
                }
            }}
            onInputChange={(event, newQuery) => {
                if (event?.type == 'change') {
                    setQuery(newQuery);

                    props.onChange({
                        ...value,
                        address: newQuery,
                    });
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={props.label}
                    autoFocus={props.autoFocus}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    sx={{
                                        position: 'absolute',
                                        right   : 9,
                                        top     : 'calc(50% - 20px)',
                                    }}
                                    onClick={checkCurrentLocation}
                                    disabled={loading}>
                                    {loading
                                        ? <CircularProgress size={24}/>
                                        : <LocationOn color="primary"/>}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    fullWidth/>
            )}

            renderOption={(props, option) => {
                return (
                    <li {...props} key={option.id}>
                        <Grid container alignItems="center">
                            <Grid item sx={{display: 'flex', width: 44}}>
                                <LocationOn sx={{color: 'text.secondary'}}/>
                            </Grid>
                            <Grid item sx={{width: 'calc(100% - 44px)', wordWrap: 'break-word'}}>

                                <Box
                                    component="span"
                                    sx={{fontWeight: 'bold'}}>
                                    {option.name}
                                </Box>

                                <Typography variant="body2" color="text.secondary">
                                    {option.address}
                                </Typography>
                            </Grid>
                        </Grid>
                    </li>
                );
            }}
        />
    );
}

FAddress.propTypes = {
    label    : PropTypes.string,
    value    : PropTypes.exact({
        address: PropTypes.string,
        lat    : PropTypes.any,
        lng    : PropTypes.any,
    }).isRequired,
    onChange : PropTypes.func.isRequired,
    disabled : PropTypes.bool,
    autoFocus: PropTypes.bool,
};

export default FAddress;